import { takeLatest, call, put, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    getAlertsRequest,
    getAlertsSuccess, getAlertsFailure,
    acknowledgeAlertSuccess, acknowledgeAlertFailure,
    bumpOrderPrioritySuccess, bumpOrderPriorityFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

const API = `${process.env.REACT_APP_SERVER_API}api/laboratory`;

function* authRequest(url, { method = 'GET', body } = {}) {
    const authToken = localStorage.getItem("item");
    if (!authToken) { yield put(logoutRequest()); return null; }
    const currentBranch = yield select(state => state.branch.currentBranch);
    const requestDetail = {
        method,
        headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
    };
    if (body !== undefined) requestDetail.body = JSON.stringify(body);
    return yield call(requestHandler, url, requestDetail);
}

function* getAlerts(action) {
    try {
        const status = action.payload?.status || 'active';
        const res = yield* authRequest(`${API}/alerts?status=${status}`);
        if (res) yield put(getAlertsSuccess(res));
    } catch (error) {
        yield put(getAlertsFailure(error?.message || error));
    }
}

function* acknowledgeAlert(action) {
    const { id, note } = action.payload || {};
    try {
        yield* authRequest(`${API}/alerts/${id}/acknowledge`, { method: 'PUT', body: { note } });
        yield put(acknowledgeAlertSuccess());
        toast.success('Alert acknowledged');
        yield put(getAlertsRequest());
    } catch (error) {
        yield put(acknowledgeAlertFailure(error?.message || error));
    }
}

function* bumpOrderPriority(action) {
    const { orderId, priority } = action.payload || {};
    try {
        yield* authRequest(`${API}/orders/${orderId}/priority`, { method: 'PUT', body: { priority } });
        yield put(bumpOrderPrioritySuccess());
        toast.success(`Priority set to ${priority}`);
        yield put(getAlertsRequest());
    } catch (error) {
        yield put(bumpOrderPriorityFailure(error?.message || error));
    }
}

function* saga() {
    yield takeLatest('labAlert/getAlertsRequest', getAlerts);
    yield takeLatest('labAlert/acknowledgeAlertRequest', acknowledgeAlert);
    yield takeLatest('labAlert/bumpOrderPriorityRequest', bumpOrderPriority);
}

export default saga;
